import React from "react";

interface IFormTextAreaProps {
  label: string;
  id: string;
  value?: string | undefined;
  required?: boolean | undefined;
  onChange: (id: string, value: string) => void;
  error?: string | undefined;
  hint?: string;
  disabled?: boolean;
}

function FormTextArea({
  label,
  id,
  value,
  required,
  onChange,
  error,
  hint,
  disabled = false,
}: IFormTextAreaProps) {
  const css: string = disabled ? "form-input-disabled" : "form-input";
  return (
    <div>
      <label htmlFor={id} className="form-label">
        {label}
        {required && <>*</>}
      </label>
      <textarea
        name={id}
        id={id}
        rows={5}
        value={value}
        className={css}
        required={required}
        onChange={(e) => onChange(id, e.target.value)}
        disabled={disabled}
      />
      {hint && <div className="form-hint">{hint}</div>}
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default FormTextArea;
